import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    url: String,
    field: String,
    model: String
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const current = this.buttonTarget.classList.contains("is-on")
    const next = !current

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const body = { [this.modelValue]: { [this.fieldValue]: next } }

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify(body)
    }).then(response => {
      if (response.ok) {
        this.buttonTarget.classList.toggle("is-on", next)
        this.buttonTarget.setAttribute("aria-pressed", next ? "true" : "false")
        const label = this.buttonTarget.querySelector(".rw-inline-toggle-label")
        if (label) label.textContent = next ? "Oui" : "Non"
        this.flashSuccess()
      }
    })
  }

  flashSuccess() {
    const field = this.element.closest(".rw-inline-field")
    if (!field) return
    field.classList.remove("is-just-saved")
    void field.offsetWidth
    field.classList.add("is-just-saved")
    setTimeout(() => field.classList.remove("is-just-saved"), 1200)
  }
}
